function normalizeUrl(url) {
  if (!url) return '';
  return url.replace(/\/+$/, '');
}

const configs = {
  test: {
    DOMAIN: normalizeUrl('http://localhost:3000/'),
    STUDENT_PORTAL_DOMAIN: normalizeUrl('https://student.learnovative.uk/'),
    API_BASE_URL: normalizeUrl('https://na.learnovative.uk/'),
    STUDENT_PORTAL_CART_CHECKOUT_URL: 'https://student.learnovative.uk/cart/checkout',
    STUDENT_PORTAL_MY_COURSES_URL: 'https://student.learnovative.uk/Courses',
    ENROLLMENTS_URL: 'https://student.learnovative.uk/api/auth/enrollments',
    LOGIN_REDIRECT_URL: 'https://student.learnovative.uk/auth/login',
    AUTH_CALLBACK_PATH: '/auth/callback',
    EXCHANGE_CODE_URL: 'https://student.learnovative.uk/api/auth/exchange-code',
    AUTH_ME_URL: 'https://student.learnovative.uk/api/auth/me',
    LOGOUT_URL: 'https://student.learnovative.uk/api/auth/logout',
  },
  prod: {
    DOMAIN: normalizeUrl('https://learnovative.uk'),
    STUDENT_PORTAL_DOMAIN: normalizeUrl('https://student.learnovative.uk'),
    API_BASE_URL: normalizeUrl('https://na.learnovative.uk/'),
    STUDENT_PORTAL_CART_CHECKOUT_URL: 'https://student.learnovative.uk/cart/checkout',
    STUDENT_PORTAL_MY_COURSES_URL: 'https://student.learnovative.uk/courses',
    ENROLLMENTS_URL: 'https://student.learnovative.uk/api/auth/enrollments',
    LOGIN_REDIRECT_URL: 'https://student.learnovative.uk/auth/login',
    AUTH_CALLBACK_PATH: '/auth/callback',
    EXCHANGE_CODE_URL: 'https://student.learnovative.uk/api/auth/exchange-code',
    AUTH_ME_URL: 'https://student.learnovative.uk/api/auth/me',
    LOGOUT_URL: 'https://student.learnovative.uk/api/auth/logout',
  },
};

const env = process.env.REACT_APP_ENV || (process.env.NODE_ENV === 'production' ? 'prod' : 'test');

export default configs[env];
